// Translates the raw ALERT.DETAILS string (written by the backend/processor
// in English, e.g. "FALL", "No Sign of Life! - Mode 2") into a display
// string for the current UI language, for customers who need an all-Japanese
// interface. Only affects what's rendered - callers that compare
// alert.DETAILS against a raw value (accuracy gating, sound matching) must
// keep using the untranslated field.
//
// Matching is by keyword, case-insensitive (NEC asked for this - new/legacy
// wording and casing shouldn't need a code change to pick up a translation),
// not exact string equality. Order matters only in that more specific
// keywords should be checked first if they could ever overlap.
const ID_RE = /id\s*:?\s*(\S+)/i
const TRACK_RE = /track\s*:?\s*(\S+)/i
const LOCATION_RE = /location\s*:?\s*(.+)$/i

const KEYWORD_RULES = [
  {
    test: /no sign of life/i,
    translate: (t, details) => {
      const track = details.match(TRACK_RE)?.[1]
      const location = details.match(LOCATION_RE)?.[1]
      if (track || location) {
        return t('alert.details.noSignOfLifeTrack', { track: track || '', location: location || '' })
      }
      return t('alert.details.noSignOfLife')
    },
  },
  {
    test: /abnormal.*heart rate|heart rate.*abnormal/i,
    translate: (t) => t('alert.details.abnormalHeartRate'),
  },
  {
    test: /abnormal.*breath rate|breath rate.*abnormal/i,
    translate: (t) => t('alert.details.abnormalBreathRate'),
  },
  {
    test: /fall/i,
    translate: (t, details) => {
      const id = details.match(ID_RE)?.[1]
      return id ? `${t('alert.details.fall')} (ID:${id})` : t('alert.details.fall')
    },
  },
]

export const translateAlertDetails = (details, t) => {
  if (!details) return details

  for (const rule of KEYWORD_RULES) {
    if (rule.test.test(details)) return rule.translate(t, details)
  }

  return details
}
